import { render, staticRenderFns } from "./MasterNavbar.vue?vue&type=template&id=b223644e&"
import script from "./MasterNavbar.vue?vue&type=script&lang=js&"
export * from "./MasterNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports